module.exports = __webpack_public_path__ + "static/media/b1.464e80a4.jpg";